import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom'; // added to get access to history object
import AppVideoPage from './AppVideoPage';
const AppVideoPageLoader = (props) => (React.createElement(Router, null,
    React.createElement(AppVideoPage, { ...props })));
export default AppVideoPageLoader;
